import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-checkmark",
  "use": "icon-checkmark-usage",
  "viewBox": "0 0 11 7",
  "content": "<symbol aria-hidden=\"true\" viewBox=\"0 0 11 7\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-checkmark\"><path d=\"m1.5 3.5 1.333 1.25L4.167 6 9.5 1\" stroke=\"currentColor\" stroke-width=\"1.75\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol